var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'c-message-alert',
    'c-message-alert--' + (_vm.message.status || 'info')
  ],on:{"click":_vm.onClick}},[_c('h2',[_vm._v(_vm._s(_vm.message.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }